var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 1.22a1 1 0 011.25 0l10 8A1 1 0 0123 10v13a1 1 0 01-1 1h-7a1 1 0 01-1-1v-6h-4v6a1 1 0 01-1 1H2a1 1 0 01-1-1V10a1 1 0 01.375-.78l10-8zM3 10.48V22h5v-6a1 1 0 011-1h6a1 1 0 011 1v6h5V10.48l-9-7.2-9 7.2z"
  })));
}
export default SvgDashboardOutline;